module.exports = __webpack_public_path__ + "img/cat1.af2f0f20.jpg";